export const workersData = [
  {
    id: '1',
    name: '木村 花',
    email: 'kimura@example.com',
    qualifications: ['保育士'],
    created_at: '2026-02-01T00:00:00Z',
    averageScore: 64.3,
    rank: 'S',
    evaluationHistory: [
      { evaluatedAt: '2026-02-25', punctuality: 5, teamwork: 5, childCare: 5, communication: 5 },
      { evaluatedAt: '2026-02-18', punctuality: 4, teamwork: 4, childCare: 5, communication: 4 },
      { evaluatedAt: '2026-02-11', punctuality: 4, teamwork: 4, childCare: 4, communication: 4 }
    ]
  },
  {
    id: '2',
    name: '小林 陸',
    email: 'kobayashi@example.com',
    qualifications: ['保育士'],
    created_at: '2026-02-03T00:00:00Z',
    averageScore: 52.2,
    rank: 'A',
    evaluationHistory: [
      { evaluatedAt: '2026-03-05', punctuality: 4, teamwork: 4, childCare: 4, communication: 4 },
      { evaluatedAt: '2026-02-28', punctuality: 4, teamwork: 4, childCare: 4, communication: 4 },
      { evaluatedAt: '2026-02-21', punctuality: 3, teamwork: 3, childCare: 4, communication: 3 },
      { evaluatedAt: '2026-02-14', punctuality: 3, teamwork: 3, childCare: 3, communication: 3 },
      { evaluatedAt: '2026-02-07', punctuality: 3, teamwork: 3, childCare: 3, communication: 3 }
    ]
  },
  {
    id: '3',
    name: '加藤 美穂',
    email: 'kato@example.com',
    qualifications: ['看護師'],
    created_at: '2026-02-05T00:00:00Z',
    averageScore: 41.5,
    rank: 'B',
    evaluationHistory: [
      { evaluatedAt: '2026-02-26', punctuality: 3, teamwork: 3, childCare: 2, communication: 3 },
      { evaluatedAt: '2026-02-19', punctuality: 3, teamwork: 2, childCare: 2, communication: 2 }
    ]
  },
  {
    id: '4',
    name: '斎藤 あかり',
    email: 'saito@example.com',
    qualifications: ['保育士', '栄養士'],
    created_at: '2026-02-07T00:00:00Z',
    averageScore: 53.0,
    rank: 'A',
    evaluationHistory: [
      { evaluatedAt: '2026-02-27', punctuality: 4, teamwork: 4, childCare: 4, communication: 4 },
      { evaluatedAt: '2026-02-20', punctuality: 3, teamwork: 3, childCare: 4, communication: 3 },
      { evaluatedAt: '2026-02-13', punctuality: 3, teamwork: 3, childCare: 3, communication: 3 }
    ]
  },
  {
    id: '5',
    name: '渡辺 大輔',
    email: 'watanabe@example.com',
    qualifications: ['保育士'],
    created_at: '2026-02-10T00:00:00Z',
    averageScore: 50.0,
    rank: 'A',
    evaluationHistory: [
      { evaluatedAt: '2026-02-28', punctuality: 2, teamwork: 2, childCare: 2, communication: 2 },
      { evaluatedAt: '2026-02-21', punctuality: 3, teamwork: 2, childCare: 3, communication: 3 },
      { evaluatedAt: '2026-02-14', punctuality: 4, teamwork: 4, childCare: 4, communication: 4 },
      { evaluatedAt: '2026-02-07', punctuality: 4, teamwork: 4, childCare: 5, communication: 4 }
    ]
  },
  {
    id: '6',
    name: '伊藤 拓也',
    email: 'ito@example.com',
    qualifications: ['保育士'],
    created_at: '2026-02-12T00:00:00Z',
    averageScore: 42.7,
    rank: 'B',
    evaluationHistory: [
      { evaluatedAt: '2026-02-27', punctuality: 3, teamwork: 3, childCare: 3, communication: 3 },
      { evaluatedAt: '2026-02-20', punctuality: 3, teamwork: 2, childCare: 3, communication: 2 },
      { evaluatedAt: '2026-02-13', punctuality: 2, teamwork: 2, childCare: 3, communication: 2 }
    ]
  },
  {
    id: '7',
    name: '石田 千尋',
    email: 'ishida@example.com',
    qualifications: ['看護師'],
    created_at: '2026-02-15T00:00:00Z',
    averageScore: 37.5,
    rank: 'ブロック',
    evaluationHistory: [
      { evaluatedAt: '2026-02-28', punctuality: 3, teamwork: 2, childCare: 3, communication: 2 },
      { evaluatedAt: '2026-02-21', punctuality: 3, teamwork: 2, childCare: 2, communication: 2 }
    ]
  },
  {
    id: '8',
    name: '森田 健二',
    email: 'morita@example.com',
    qualifications: ['保育士'],
    created_at: '2026-02-20T00:00:00Z',
    averageScore: 28.0,
    rank: 'ブロック',
    evaluationHistory: [
      { evaluatedAt: '2026-02-24', punctuality: 2, teamwork: 2, childCare: 1, communication: 2 }
    ]
  }
];

export const mockEvaluations = [
  // 木村 花 (ID: 1) - Sランク：70.7点 (評価数: 3件)
  {
    id: '1',
    worker_id: '1',
    顧客目線_rating: 9,
    笑顔_rating: 10,
    園の方針_rating: 9,
    事前準備_rating: 6,
    雰囲気_rating: 9,
    運資質_rating: 8,
    清潔感_rating: 10,
    態度_rating: 9,
    work_date: '2026-02-25',
    overall_comment: '全ての面で最高レベルの評価です。他のスタッフの模範となる存在です。',
    evaluator_name: '田村 美咲',
    created_at: '2026-02-25T18:00:00Z'
  },
  {
    id: '2',
    worker_id: '1',
    顧客目線_rating: 9,
    笑顔_rating: 10,
    園の方針_rating: 8,
    事前準備_rating: 4,
    雰囲気_rating: 8,
    運資質_rating: 7,
    清潔感_rating: 9,
    態度_rating: 9,
    work_date: '2026-02-18',
    overall_comment: '高い専門性と子どもたちへの愛情が感じられます。',
    evaluator_name: '中村 健太',
    created_at: '2026-02-18T18:00:00Z'
  },
  {
    id: '3',
    worker_id: '1',
    顧客目線_rating: 8,
    笑顔_rating: 9,
    園の方針_rating: 8,
    事前準備_rating: 4,
    雰囲気_rating: 7,
    運資質_rating: 6,
    清潔感_rating: 9,
    態度_rating: 8,
    work_date: '2026-02-11',
    overall_comment: '継続的に高いパフォーマンスを維持しています。',
    evaluator_name: '林 さくら',
    created_at: '2026-02-11T18:00:00Z'
  },

  // 小林 陸 (ID: 2) - Aランク：53.0点（成長曲線）(評価数: 5件)
  {
    id: '23',
    worker_id: '2',
    顧客目線_rating: 6,
    笑顔_rating: 4,
    園の方針_rating: 8,
    事前準備_rating: 9,
    雰囲気_rating: 6,
    運資質_rating: 10,
    清潔感_rating: 7,
    態度_rating: 8,
    work_date: '2026-03-05',
    overall_comment: '前回より更に成長が見られます。引き続き期待しています。',
    evaluator_name: '田村 美咲',
    created_at: '2026-03-05T18:00:00Z'
  },
  {
    id: '4',
    worker_id: '2',
    顧客目線_rating: 6,
    笑顔_rating: 4,
    園の方針_rating: 8,
    事前準備_rating: 8,
    雰囲気_rating: 5,
    運資質_rating: 9,
    清潔感_rating: 7,
    態度_rating: 7,
    work_date: '2026-02-28',
    overall_comment: '著しい成長が見られます。Aランクに相応しい実力です。',
    evaluator_name: '松本 陽介',
    created_at: '2026-02-28T18:00:00Z'
  },
  {
    id: '5',
    worker_id: '2',
    顧客目線_rating: 6,
    笑顔_rating: 4,
    園の方針_rating: 7,
    事前準備_rating: 8,
    雰囲気_rating: 5,
    運資質_rating: 9,
    清潔感_rating: 6,
    態度_rating: 7,
    work_date: '2026-02-21',
    overall_comment: '着実に向上しています。このペースを維持してください。',
    evaluator_name: '中村 健太',
    created_at: '2026-02-21T18:00:00Z'
  },
  {
    id: '6',
    worker_id: '2',
    顧客目線_rating: 5,
    笑顔_rating: 4,
    園の方針_rating: 7,
    事前準備_rating: 8,
    雰囲気_rating: 5,
    運資質_rating: 9,
    清潔感_rating: 6,
    態度_rating: 7,
    work_date: '2026-02-14',
    overall_comment: '改善の兆しが見えてきました。今後に期待します。',
    evaluator_name: '林 さくら',
    created_at: '2026-02-14T18:00:00Z'
  },
  {
    id: '7',
    worker_id: '2',
    顧客目線_rating: 5,
    笑顔_rating: 3,
    園の方針_rating: 7,
    事前準備_rating: 7,
    雰囲気_rating: 4,
    運資質_rating: 8,
    清潔感_rating: 6,
    態度_rating: 6,
    work_date: '2026-02-07',
    overall_comment: '基本的なスキルは身についています。',
    evaluator_name: '田村 美咲',
    created_at: '2026-02-07T18:00:00Z'
  },

  // 加藤 美穂 (ID: 3) - Bランク：42.0点 (評価数: 2件)
  {
    id: '8',
    worker_id: '3',
    顧客目線_rating: 6,
    笑顔_rating: 3,
    園の方針_rating: 4,
    事前準備_rating: 7,
    雰囲気_rating: 3,
    運資質_rating: 5,
    清潔感_rating: 8,
    態度_rating: 5,
    work_date: '2026-02-26',
    overall_comment: '看護師としての専門性は高いですが、保育面での向上が必要です。',
    evaluator_name: '松本 陽介',
    created_at: '2026-02-26T18:00:00Z'
  },
  {
    id: '9',
    worker_id: '3',
    顧客目線_rating: 5,
    笑顔_rating: 3,
    園の方針_rating: 4,
    事前準備_rating: 7,
    雰囲気_rating: 3,
    運資質_rating: 5,
    清潔感_rating: 9,
    態度_rating: 6,
    work_date: '2026-02-19',
    overall_comment: '医療面でのサポートは良好ですが、子どもとのコミュニケーションに課題があります。',
    evaluator_name: '中村 健太',
    created_at: '2026-02-19T18:00:00Z'
  },

  // 斎藤 あかり (ID: 4) - Aランク：54.0点 (評価数: 3件)
  {
    id: '10',
    worker_id: '4',
    顧客目線_rating: 8,
    笑顔_rating: 9,
    園の方針_rating: 6,
    事前準備_rating: 4,
    雰囲気_rating: 10,
    運資質_rating: 6,
    清潔感_rating: 7,
    態度_rating: 7,
    work_date: '2026-02-27',
    overall_comment: '保育士と栄養士の両資格を活かした素晴らしい働きです。',
    evaluator_name: '林 さくら',
    created_at: '2026-02-27T18:00:00Z'
  },
  {
    id: '11',
    worker_id: '4',
    顧客目線_rating: 7,
    笑顔_rating: 9,
    園の方針_rating: 6,
    事前準備_rating: 4,
    雰囲気_rating: 9,
    運資質_rating: 5,
    清潔感_rating: 6,
    態度_rating: 6,
    work_date: '2026-02-20',
    overall_comment: 'チームワークが素晴らしく、他スタッフとの連携も良好です。',
    evaluator_name: '田村 美咲',
    created_at: '2026-02-20T18:00:00Z'
  },
  {
    id: '12',
    worker_id: '4',
    顧客目線_rating: 7,
    笑顔_rating: 8,
    園の方針_rating: 5,
    事前準備_rating: 4,
    雰囲気_rating: 9,
    運資質_rating: 5,
    清潔感_rating: 6,
    態度_rating: 6,
    work_date: '2026-02-13',
    overall_comment: '栄養面での専門知識を活かした指導が評価されています。',
    evaluator_name: '中村 健太',
    created_at: '2026-02-13T18:00:00Z'
  },

  // 渡辺 大輔 (ID: 5) - Aランク：50.5点（下降傾向）(評価数: 4件)
  {
    id: '13',
    worker_id: '5',
    顧客目線_rating: 6,
    笑顔_rating: 3,
    園の方針_rating: 7,
    事前準備_rating: 6,
    雰囲気_rating: 4,
    運資質_rating: 5,
    清潔感_rating: 6,
    態度_rating: 7,
    work_date: '2026-02-28',
    overall_comment: '最近大幅なパフォーマンスの低下が見られます。緊急に改善が必要です。',
    evaluator_name: '松本 陽介',
    created_at: '2026-02-28T18:00:00Z'
  },
  {
    id: '14',
    worker_id: '5',
    顧客目線_rating: 7,
    笑顔_rating: 3,
    園の方針_rating: 8,
    事前準備_rating: 6,
    雰囲気_rating: 5,
    運資質_rating: 5,
    清潔感_rating: 7,
    態度_rating: 8,
    work_date: '2026-02-21',
    overall_comment: '以前より評価が下がってきています。要注意です。',
    evaluator_name: '林 さくら',
    created_at: '2026-02-21T18:00:00Z'
  },
  {
    id: '15',
    worker_id: '5',
    顧客目線_rating: 6,
    笑顔_rating: 4,
    園の方針_rating: 8,
    事前準備_rating: 8,
    雰囲気_rating: 3,
    運資質_rating: 6,
    清潔感_rating: 8,
    態度_rating: 9,
    work_date: '2026-02-14',
    overall_comment: 'この頃は優秀なAランクの評価でした。',
    evaluator_name: '田村 美咲',
    created_at: '2026-02-14T18:00:00Z'
  },
  {
    id: '16',
    worker_id: '5',
    顧客目線_rating: 6,
    笑顔_rating: 4,
    園の方針_rating: 9,
    事前準備_rating: 8,
    雰囲気_rating: 4,
    運資質_rating: 7,
    清潔感_rating: 8,
    態度_rating: 9,
    work_date: '2026-02-07',
    overall_comment: 'トップクラスの優秀な評価でした。何があったのでしょうか。',
    evaluator_name: '中村 健太',
    created_at: '2026-02-07T18:00:00Z'
  },

  // 伊藤 拓也 (ID: 6) - Bランク：42.0点 (評価数: 3件)
  {
    id: '17',
    worker_id: '6',
    顧客目線_rating: 6,
    笑顔_rating: 9,
    園の方針_rating: 6,
    事前準備_rating: 4,
    雰囲気_rating: 8,
    運資質_rating: 4,
    清潔感_rating: 5,
    態度_rating: 6,
    work_date: '2026-02-27',
    overall_comment: '男性保育士として貴重な存在です。子どもたちにも人気があります。',
    evaluator_name: '松本 陽介',
    created_at: '2026-02-27T18:00:00Z'
  },
  {
    id: '18',
    worker_id: '6',
    顧客目線_rating: 6,
    笑顔_rating: 8,
    園の方針_rating: 5,
    事前準備_rating: 3,
    雰囲気_rating: 7,
    運資質_rating: 3,
    清潔感_rating: 4,
    態度_rating: 6,
    work_date: '2026-02-20',
    overall_comment: '体育活動では子どもたちのお兄さん的な存在として活躍しています。',
    evaluator_name: '林 さくら',
    created_at: '2026-02-20T18:00:00Z'
  },
  {
    id: '19',
    worker_id: '6',
    顧客目線_rating: 5,
    笑顔_rating: 7,
    園の方針_rating: 5,
    事前準備_rating: 3,
    雰囲気_rating: 6,
    運資質_rating: 3,
    清潔感_rating: 3,
    態度_rating: 6,
    work_date: '2026-02-13',
    overall_comment: 'コミュニケーション面でのさらなる向上が期待されます。',
    evaluator_name: '田村 美咲',
    created_at: '2026-02-13T18:00:00Z'
  },

  // 石田 千尋 (ID: 7) - ブロック：39.0点 (評価数: 2件)
  {
    id: '20',
    worker_id: '7',
    顧客目線_rating: 6,
    笑顔_rating: 5,
    園の方針_rating: 3,
    事前準備_rating: 3,
    雰囲気_rating: 4,
    運資質_rating: 7,
    清潔感_rating: 6,
    態度_rating: 3,
    work_date: '2026-02-28',
    overall_comment: '看護師としてのスキルは高いですが、保育面での改善が必要です。',
    evaluator_name: '中村 健太',
    created_at: '2026-02-28T18:00:00Z'
  },
  {
    id: '21',
    worker_id: '7',
    顧客目線_rating: 7,
    笑顔_rating: 5,
    園の方針_rating: 3,
    事前準備_rating: 2,
    雰囲気_rating: 5,
    運資質_rating: 8,
    清潔感_rating: 5,
    態度_rating: 3,
    work_date: '2026-02-21',
    overall_comment: '医療面でのサポートは良好ですが、園の方針理解に課題があります。',
    evaluator_name: '松本 陽介',
    created_at: '2026-02-21T18:00:00Z'
  },

  // 森田 健二 (ID: 8) - ブロック：28.0点 (評価数: 1件)
  {
    id: '22',
    worker_id: '8',
    顧客目線_rating: 4,
    笑顔_rating: 4,
    園の方針_rating: 2,
    事前準備_rating: 3,
    雰囲気_rating: 4,
    運資質_rating: 3,
    清潔感_rating: 5,
    態度_rating: 3,
    work_date: '2026-02-24',
    overall_comment: '態度や準備不足が目立ちます。改善が見られないためブロック対象です。',
    evaluator_name: '林 さくら',
    created_at: '2026-02-24T18:00:00Z'
  }
];

export const mockOnboardings = [
  {
    id: '1',
    worker_id: '1',
    commute_method: '自家用車',
    created_at: '2026-02-01T00:00:00Z'
  },
  {
    id: '2',
    worker_id: '2',
    commute_method: '公共交通機関',
    created_at: '2026-02-03T00:00:00Z'
  },
  {
    id: '3',
    worker_id: '3',
    commute_method: '自家用車',
    created_at: '2026-02-05T00:00:00Z'
  },
  {
    id: '4',
    worker_id: '4',
    commute_method: '自転車',
    created_at: '2026-02-07T00:00:00Z'
  },
  {
    id: '5',
    worker_id: '5',
    commute_method: '自家用車',
    created_at: '2026-02-10T00:00:00Z'
  },
  {
    id: '6',
    worker_id: '6',
    commute_method: '公共交通機関',
    created_at: '2026-02-12T00:00:00Z'
  },
  {
    id: '7',
    worker_id: '7',
    commute_method: '自家用車',
    created_at: '2026-02-15T00:00:00Z'
  },
  {
    id: '8',
    worker_id: '8',
    commute_method: '自転車',
    created_at: '2026-02-20T00:00:00Z'
  }
];

// 評価データを更新してワーカー情報を再計算する関数を追加
export const updateWorkerEvaluations = (workerId: string, newEvaluation: any) => {
  // 新しい評価をモック評価データに追加
  mockEvaluations.push({
    id: `eval_${Date.now()}`,
    worker_id: workerId,
    work_date: newEvaluation.work_date,
    顧客目線_rating: newEvaluation.顧客目線_rating,
    笑顔_rating: newEvaluation.笑顔_rating,
    園の方針_rating: newEvaluation.園の方針_rating,
    事前準備_rating: newEvaluation.事前準備_rating,
    雰囲気_rating: newEvaluation.雰囲気_rating,
    運資質_rating: newEvaluation.運資質_rating,
    清潔感_rating: newEvaluation.清潔感_rating,
    態度_rating: newEvaluation.態度_rating,
    overall_comment: newEvaluation.overall_comment,
    evaluator_name: newEvaluation.evaluator_name,
    created_at: new Date().toISOString(),
  });

  // ワーカー情報を再計算
  const workerIndex = workersData.findIndex(w => w.id === workerId);
  if (workerIndex !== -1) {
    const workerEvaluations = mockEvaluations.filter(e => e.worker_id === workerId);
    
    if (workerEvaluations.length > 0) {
      // 平均スコアを計算（10点満点ベース）
      const categories = [
        '顧客目線_rating', '笑顔_rating', '園の方針_rating', '事前準備_rating',
        '雰囲気_rating', '運資質_rating', '清潔感_rating', '態度_rating'
      ];
      
      const totalScore = workerEvaluations.reduce((acc, ev) => {
        return acc + categories.reduce((sum, key) => sum + (ev[key] || 5), 0);
      }, 0) / workerEvaluations.length;
      
      // ランクを判定
      let rank = 'B';
      if (totalScore >= 60) rank = 'S';
      else if (totalScore >= 50) rank = 'A';
      else if (totalScore < 40) rank = 'ブロック';
      
      // ワーカー情報を更新
      workersData[workerIndex] = {
        ...workersData[workerIndex],
        averageScore: totalScore,
        rank: rank,
        evaluationHistory: workerEvaluations.map(ev => ({
          evaluatedAt: ev.work_date,
          evaluatorName: ev.evaluator_name || '未記入',
          punctuality: ev.事前準備_rating || 5,
          teamwork: ev.雰囲気_rating || 5,
          childCare: ev.顧客目線_rating || 5,
          communication: ev.笑顔_rating || 5,
        })).sort((a, b) => new Date(b.evaluatedAt).getTime() - new Date(a.evaluatedAt).getTime())
      };
    }
  }
  
  return workersData[workerIndex];
};

// ワーカーデータを取得する関数（更新された情報を返す）
export const getUpdatedWorkersData = () => {
  return [...workersData];
};
